import React, { useEffect } from 'react';
import { X } from 'lucide-react';

// Modal genérico — overlay + painel centralizado, fecha no X, clicando fora
// ou pressionando Esc. Usado pelos modais "Configurar Enquete" e "Editar
// Perguntas" em GerenciarEnquetes.js, entre outros. Header colorido
// (bg-primary-600) e X com fundo/contorno visível em TODO modal daqui pra
// frente — era quase invisível antes (text-gray-400 sem nada em repouso).
// O rodapé de botões (centralizado se 1, esquerda/direita se 2) fica a
// cargo de cada conteúdo via ModalRodape.js — não dá pra padronizar isso
// aqui dentro porque cada modal tem uma quantidade/tipo de ação diferente
// (formulário com 1 botão, confirmação com Cancelar+Ação, etc.).
// `rodapeFechar` continua existindo só pros conteúdos sem nenhum botão
// próprio (ex: Compartilhar Link, Legenda de Cores).
const Modal = ({ titulo, onFechar, children, maxWidth = 'max-w-lg', rodapeFechar = false }) => {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onFechar();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onFechar]);

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-[2px]" onClick={onFechar} />
      <div
        className={`relative w-full ${maxWidth} max-h-[92vh] sm:max-h-[88vh] overflow-y-auto rounded-t-2xl sm:rounded-2xl bg-white shadow-2xl animate-modal-in`}
      >
        <div className="sticky top-0 z-10 flex items-center justify-between px-4 sm:px-6 py-3.5 sm:py-4 bg-primary-600">
          <h2 className="font-semibold text-sm sm:text-base truncate pr-3 text-white">{titulo}</h2>
          <button
            onClick={onFechar}
            className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-white bg-white/20 border border-white/30 hover:bg-white/30 transition-colors"
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 sm:p-6">{children}</div>
        {rodapeFechar && (
          <div className="flex justify-center border-t border-gray-100 px-4 sm:px-6 py-3.5 sm:py-4">
            <button onClick={onFechar} className="btn-primary px-8">
              Fechar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
